// @ts-nocheck
import { Popover, Typography } from "antd";
import { Controller, Control } from "react-hook-form";
import { CirclePicker, SketchPicker } from "react-color";

const { Text } = Typography;

const PRESET_COLORS = [
  "#FE4914",
  "#0B2D9C",
  "#3B82F6",
  "#705957",
  "#E5B09E",
  "#FACC15",
  "#4bd542",
  "#ff4d4f",
  "#1B1C1B",
  "#FFFFFF",
  "#F4EFE7",
  "#000000",
];

type Props = {
  name: "pill_bg_color" | "pill_text_color";
  control: Control<any>;
  label: string;
  defaultValue?: string;
};

export function CampaignColorField({
  name,
  control,
  label,
  defaultValue = "#FE4914",
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => {
        const color = value || defaultValue;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "100%",
              gap: 8,
            }}
          >
            <Typography.Title style={{ marginBottom: 0 }} level={5}>
              {label}
            </Typography.Title>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <Popover
                trigger="click"
                placement="bottomLeft"
                content={
                  <div>
                    <SketchPicker
                      color={color}
                      onChange={(c) => onChange(c.hex)}
                      disableAlpha
                      presetColors={PRESET_COLORS}
                    />
                  </div>
                }
              >
                <button
                  type="button"
                  aria-label={`Elegir ${label.toLowerCase()}`}
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 10,
                    border: "2px solid #d9d9d9",
                    backgroundColor: color,
                    cursor: "pointer",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                    flexShrink: 0,
                  }}
                />
              </Popover>

              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Clic en el cuadro para abrir el selector
                </Text>
                <div style={{ fontSize: 12, fontWeight: 600, marginTop: 2 }}>
                  {String(color).toUpperCase()}
                </div>
              </div>
            </div>

            <CirclePicker
              color={color}
              colors={PRESET_COLORS}
              width="100%"
              circleSize={22}
              circleSpacing={8}
              onChangeComplete={(c) => onChange(c.hex)}
            />
          </div>
        );
      }}
    />
  );
}
